"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ScrollIntoView;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Place at end of scrolling list to transition to the end of list when count increases */
function ScrollIntoView({
  count
}) {
  const endRef = (0, _react.useRef)(null);
  const lastCount = (0, _react.useRef)(count);
  (0, _react.useEffect)(() => {
    if (count > lastCount.current) endRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
    lastCount.current = count;
  }, [count]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: endRef
  });
}